export const FIREBASE_INTEGRATION = 'firebase';
export const SMS_INTEGRATION = 'smsc';
export const KGD_INTEGRATION = 'kgd';
export const BCC_INTEGRATION = 'bcc';
